(function () {
  const GRID_SELECTOR = '.campaigns-wrapper';
  const OUTER_TILE_CLASS = 'yotpo-outer-tile';
  const POLL_MS = 200;
  const DESKTOP_HOVER_MQ = '(hover: hover) and (pointer: fine)';

  const roots = document.querySelectorAll('[data-yotpo-earn-tiles]');
  if (!roots.length) return;

  function isOurNode(el) {
    return Boolean(
      el &&
        (el.hasAttribute('data-yotpo-earn-tile-wrap') ||
          el.hasAttribute('data-yotpo-earn-tile') ||
          el.classList.contains('yotpo-earn-tile'))
    );
  }

  function findCampaignGrid() {
    return document.querySelector(GRID_SELECTOR);
  }

  function nativeSample(grid) {
    return Array.from(grid.children).find(
      (child) => !isOurNode(child) && child.classList.contains(OUTER_TILE_CLASS)
    );
  }

  function ensureWrap(tile, grid) {
    let wrap = tile.parentElement;
    if (!wrap || !wrap.hasAttribute('data-yotpo-earn-tile-wrap')) {
      wrap = document.createElement('div');
      wrap.setAttribute('data-yotpo-earn-tile-wrap', '');
      wrap.appendChild(tile);
    }

    const sample = nativeSample(grid);
    wrap.className = sample ? sample.className : OUTER_TILE_CLASS;
    wrap.setAttribute('role', sample ? sample.getAttribute('role') || 'listitem' : 'listitem');
    wrap.setAttribute('tabindex', '-1');
    wrap.setAttribute('data-yotpo-earn-tile-wrap', '');

    if (sample && sample.getAttribute('style')) {
      wrap.setAttribute('style', sample.getAttribute('style'));
    }

    if (wrap.parentElement !== grid) {
      grid.appendChild(wrap);
    }

    return wrap;
  }

  function inject(tiles) {
    if (!tiles.length) return false;

    const grid = findCampaignGrid();
    if (!grid || !nativeSample(grid)) return false;

    const alreadyInjected = tiles.every((tile) => {
      const wrap = tile.parentElement;
      return wrap && wrap.hasAttribute('data-yotpo-earn-tile-wrap') && wrap.parentElement === grid;
    });

    if (!alreadyInjected) {
      tiles.forEach((tile) => ensureWrap(tile, grid));
    }

    return true;
  }

  function usesDesktopHover() {
    // DevTools "mobile" often still reports hover:fine. Prefer dialog under 750px.
    if (window.matchMedia('(max-width: 749px)').matches) return false;
    return window.matchMedia(DESKTOP_HOVER_MQ).matches;
  }

  const identifiedEmails = new Set();

  function identifyKlaviyoEmail(email) {
    if (identifiedEmails.has(email)) return;
    identifiedEmails.add(email);

    const payload = { email };
    const klaviyo = window.klaviyo;

    if (klaviyo && typeof klaviyo.identify === 'function') {
      klaviyo.identify(payload);
      return;
    }

    if (klaviyo && typeof klaviyo.push === 'function') {
      klaviyo.push(['identify', payload]);
      return;
    }

    window._learnq = window._learnq || [];
    window._learnq.push(['identify', payload]);
  }

  function remountEmptyKlaviyoEmbeds(root) {
    if (!root) return;
    root.querySelectorAll('[class^="klaviyo-form-"]').forEach((el) => {
      if (el.childElementCount > 0) return;
      // Replace empty mount points so Klaviyo will initialize them now that they are visible.
      el.replaceWith(el.cloneNode(false));
    });
  }

  function fillSmsTileEmail() {
    document.querySelectorAll('[data-yotpo-sms-tile][data-customer-email]').forEach((tile) => {
      const email = tile.getAttribute('data-customer-email');
      if (!email) return;

      identifyKlaviyoEmail(email);

      tile.querySelectorAll('input[type="email"]').forEach((input) => {
        if (input.value === email) return;
        input.value = email;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function restoreForm(tile) {
    const form = tile.querySelector('[data-yotpo-earn-form]');
    const dialog = tile.querySelector('[data-yotpo-earn-dialog]');
    if (!form || !dialog) return;

    form.style.opacity = '';
    form.style.visibility = '';
    form.style.pointerEvents = '';

    if (form.parentElement !== tile) {
      tile.insertBefore(form, dialog);
    }
  }

  function openTileDialog(tile) {
    const form = tile.querySelector('[data-yotpo-earn-form]');
    const dialog = tile.querySelector('[data-yotpo-earn-dialog]');
    const body = dialog && dialog.querySelector('[data-yotpo-earn-dialog-body]');
    if (!form || !dialog || !body) return;

    if (form.parentElement !== body) {
      body.appendChild(form);
    }

    // Tile form starts hidden for hover; guarantee visibility inside the dialog.
    form.style.opacity = '1';
    form.style.visibility = 'visible';
    form.style.pointerEvents = 'auto';

    remountEmptyKlaviyoEmbeds(form);
    fillSmsTileEmail();

    // Klaviyo may skip embeds that were visibility:hidden; nudge a re-scan.
    window.dispatchEvent(new Event('klaviyoForms'));

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    // Prefill again after Klaviyo paints inputs.
    window.setTimeout(fillSmsTileEmail, 300);
    window.setTimeout(fillSmsTileEmail, 1000);
  }

  function closeTileDialog(tile) {
    const dialog = tile.querySelector('[data-yotpo-earn-dialog]');
    if (!dialog) return;

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }

    restoreForm(tile);
  }

  function bindTileDialogs(tiles) {
    tiles.forEach((tile) => {
      if (tile.dataset.dialogBound === 'true') return;
      if (!tile.classList.contains('yotpo-earn-tile--has-overlay')) return;

      const dialog = tile.querySelector('[data-yotpo-earn-dialog]');
      const closeBtn = tile.querySelector('[data-yotpo-earn-dialog-close]');
      if (!dialog) return;

      tile.dataset.dialogBound = 'true';

      const onActivate = (event) => {
        if (usesDesktopHover()) return;
        if (event.target.closest('[data-yotpo-earn-dialog]')) return;
        if (event.target.closest('a')) return;

        event.preventDefault();
        openTileDialog(tile);
      };

      tile.addEventListener('click', onActivate);
      tile.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (usesDesktopHover()) return;
        if (event.target.closest('[data-yotpo-earn-dialog]')) return;
        if (event.target.closest('a')) return;

        event.preventDefault();
        openTileDialog(tile);
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          closeTileDialog(tile);
        });
      }

      dialog.addEventListener('close', () => {
        restoreForm(tile);
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeTileDialog(tile);
        }
      });

      const revealForm = () => {
        const form = tile.querySelector('[data-yotpo-earn-form]');
        if (!form) return;
        remountEmptyKlaviyoEmbeds(form);
        fillSmsTileEmail();
        window.dispatchEvent(new Event('klaviyoForms'));
      };
      tile.addEventListener('mouseenter', revealForm);
      tile.addEventListener('focusin', revealForm);
    });
  }

  roots.forEach((root) => {
    const tiles = Array.from(root.querySelectorAll('[data-yotpo-earn-tile]'));
    let done = false;
    let pollId = null;
    let observer = null;

    bindTileDialogs(tiles);

    const cleanupWaiters = () => {
      if (pollId) window.clearInterval(pollId);
      if (observer) observer.disconnect();
      pollId = null;
      observer = null;
    };

    const runInject = () => {
      if (done) return;
      if (!inject(tiles)) return;

      done = true;
      cleanupWaiters();
      root.removeAttribute('inert');
      bindTileDialogs(tiles);
      fillSmsTileEmail();

      observer = new MutationObserver(() => {
        const grid = findCampaignGrid();
        if (!grid) return;

        const missing = tiles.some((tile) => {
          const wrap = tile.parentElement;
          return !(wrap && wrap.hasAttribute('data-yotpo-earn-tile-wrap') && wrap.parentElement === grid);
        });

        if (missing) inject(tiles);
        bindTileDialogs(tiles);
        fillSmsTileEmail();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    runInject();
    if (done) return;

    pollId = window.setInterval(runInject, POLL_MS);
    observer = new MutationObserver(runInject);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.addEventListener('klaviyoForms', fillSmsTileEmail);
  fillSmsTileEmail();
})();
